// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import QRCode from "react-qr-code";
import {
  MessageBar,
  Button,
  Dialog,
  Input,
  Field,
  DialogSurface,
  DialogBody,
  DialogContent,
  DialogTitle,
  Text,
} from "@fluentui/react-components";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import { CopyRegular, DismissRegular } from "@fluentui/react-icons";

// Props
interface IDeleteMediathekDocumentDialogProps {
  isDialogOpen: boolean;
  link: string | undefined;
  onDismiss: any;
}

// Function
function MediathekShortLinkDialog(props: IDeleteMediathekDocumentDialogProps) {
  const [linkCopiedToClipboard, setLinkCopiedToClipboard] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setLinkCopiedToClipboard(true);
    });
  };

  useEffect(() => {
    setLinkCopiedToClipboard(false);
  }, []);

  return (
    <div>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogTitle>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {i18n.t<string>("mediathekShortLink")}
              <Button
                appearance="transparent"
                onClick={() => {
                  props.onDismiss();
                }}
                icon={<DismissRegular />}
              />
            </div>
          </DialogTitle>
          <DialogBody>
            <DialogContent>
              <Text>{i18n.t<string>("mediathekShortLinkText")}</Text>
              <StackShim tokens={{ childrenGap: 5 }}>
                <Field label="Link">
                  <Input
                    contentAfter={
                      <Button
                        appearance="transparent"
                        icon={<CopyRegular />}
                        onClick={() => {
                          if (props.link) {
                            copyToClipboard(props.link);
                          }
                        }}
                      />
                    }
                    readOnly
                    appearance="filled-darker"
                    value={props.link}
                  />
                </Field>

                {linkCopiedToClipboard && (
                  <MessageBar intent={"success"}>
                    {i18n.t<string>("linkCopiedToClipboard")}
                  </MessageBar>
                )}

                <StackItemShim align="center" grow={1}>
                  <QRCode value={props.link ? props.link : ""} />
                </StackItemShim>
              </StackShim>
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

// Export Function
export default MediathekShortLinkDialog;
